import { render } from "./StartFreeTrialButton.vue?vue&type=template&id=0ca4a25f&scoped=true"
const script = {}

import "./StartFreeTrialButton.vue?vue&type=style&index=0&id=0ca4a25f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4a25f"]])

export default __exports__